<template>
    <div class="">
        <navbar></navbar>
        <div class="ipoint-success">
            <div class="ipoint-success-content">
                <img src="../../assets/profile/error.png" alt="">
                <p class="ipoint-remaining">Remaining: {{ipoint}}</p>
                <router-link :to="{name:'Store'}">
                    <a class="ipoint-continue-shopping" href="javascript:;">Continue shopping
                        <Icon type="chevron-right"></Icon>
                    </a>
                </router-link>
            </div>
        </div>
    </div>

</template>
<script>
    import message from './Common/Message.vue'
    import navbar from '../Common/Navbar.vue'
    import Signature from '../../lib/Signature'

    export default {
        data() {
            return {
                ipoint: ''
            }
        },
        components: {
            message, navbar
        },
        created () {
            let module = 'index.php/index/user/info'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            this.$http.get(process.env.BASEURL + module, {
                params: data
            }).then(function (response) {
                if (parseInt(response.data.code) === 2000) {
                    this.ipoint = response.data.data.userinfo.ipoint
                }
            }.bind(this))
        }
    }
</script>
<style lang="scss">
    .ipoint-success {
        margin-top: 80px;
    }

    .ipoint-success-content {
        width: 80%;
        margin: 0 auto;
        background-color: white;
        padding: 50px 150px;
        margin-bottom: 200px;
    p {
        font-size: 24px;
        color: #5E6D82;
        letter-spacing: 0
    }
    .ipoint-remaining {
        font-size: 40px;
        color: #1F2D3D;
        letter-spacing: 0;
    }
    .ipoint-continue-shopping {
        font-size: 16px;
        color: #0084FF;
        display: block;
    & > i {
            vertical-align: middle;
        }
    }

    }

    @media screen and (max-width: 768px){
        .ipoint-success{
        .ipoint-success-content{
            width: 100%;
            padding: 5%;
            margin: 0;
        }
    }
    }

    @media screen and (max-width: 414px){
        .ipoint-success{
        .ipoint-success-content{
            padding-top:100px;
        img{
            width:25%;
        }
        p{
            font-size: 28px;
        }
    }
    }
    }
</style>



// WEBPACK FOOTER //
// iPointError.vue?0b5569b8